export default __webpack_public_path__ + "static/media/insta-sp.fcfa5c24.png";